import { verifyW3CSignature } from '../../../w3c/verify';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const w3cSignatureIntegrity = {
  skip: /* @__PURE__ */ __name(async () => {
    return {
      type: "DOCUMENT_INTEGRITY",
      name: "W3CSignatureIntegrity",
      reason: {
        code: 0,
        codeString: "SKIPPED",
        message: `Document either has no proof or proof.type is not 'BbsBlsSignature2020'.`
      },
      status: "SKIPPED"
    };
  }, "skip"),
  test: /* @__PURE__ */ __name((document) => {
    const doc = document;
    return doc.proof?.type === "BbsBlsSignature2020" || doc.proof?.type === "BbsBlsSignatureProof2020";
  }, "test"),
  verify: /* @__PURE__ */ __name(async (document, verifierOptions) => {
    const doc = document;
    const verificationResult = await verifyW3CSignature(doc, verifierOptions);
    if (verificationResult.verified) {
      return {
        type: "DOCUMENT_INTEGRITY",
        name: "W3CSignatureIntegrity",
        data: true,
        status: "VALID"
      };
    } else {
      return {
        type: "DOCUMENT_INTEGRITY",
        name: "W3CSignatureIntegrity",
        data: false,
        reason: {
          message: verificationResult.error
        },
        status: "INVALID"
      };
    }
  }, "verify")
};

export { w3cSignatureIntegrity };
